import { useAppSelector } from "app/hooks";
import { BSelect } from "components";
import { selectActiveProductCategories } from "features/admin/catalog/Catalog.slice";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export interface CategorySelectProps {
  required?: boolean;
  onChange?: (value: string | undefined) => void;
  error?: ReactNode;
  value?: string; // could be undefined if form has no initial values
  disabled?: boolean;
}

export const CategorySelect = (props: CategorySelectProps) => {
  const { t } = useTranslation();
  const items = useAppSelector(selectActiveProductCategories);
  const data = items.map((o) => ({ value: o.id, label: o.name }));

  return (
    <BSelect
      {...props}
      data={data}
      label={t("BUNDLE_CATEGORY")}
      nothingFound={t("NOTHING_FOUND")}
    />
  );
};
